import { ApplicationsContent } from '../../graphql/pimcore/modules/siteContent/types/ApplicationsContent';
import React, { lazy, useMemo } from 'react';
import { ComponentInfo } from '../industrialPage/IndustrialDisplayComponent';
import { DefaultComputing } from './ComputingImageComponent';
import { BmsLowVoltImage } from '../automotivePage/CarImageComponent';
import { LowVoltDcImage } from './CommercialSVGs';

const TractionInverterImage = lazy(() =>
    import('./CommercialSVGs').then((m) => ({ default: m.TractionInverterImage }))
);
const PowerConversionImage = lazy(() =>
    import('./CommercialSVGs').then((m) => ({ default: m.PowerConversionImage }))
);

export const useComputingComponents = (
    contentTree: ApplicationsContent
): {
    components: { [key: string]: ComponentInfo };
} => {
    const components = useMemo<{ [key: string]: ComponentInfo }>(() => {
        const computing = contentTree.ComputingAndEnterpriseSystems.Computing;
        const t = computing.imageMapLinkTexts;

        return {
            computingEnterpriseSystems: {
                label: computing.title.content,
                component: (props) =>
                    React.createElement(DefaultComputing, { ...props, contentTree }),
            },
            climatecontrol: {
                label: t.climateControl.content,
                imageComponent: PowerConversionImage,
            },
            upsbatteries: {
                label: t.upsBatteries.content,
                imageComponent: BmsLowVoltImage,
            },
            mainpowerdistribution: {
                label: t.mainPowerDistribution.content,
                imageComponent: PowerConversionImage,
            },
            edgecomputing: {
                label: t.edgeComputing.content,
                imageComponent: LowVoltDcImage,
            },
            generator: {
                label: t.generator.content,
                imageComponent: TractionInverterImage,
            },
            networkpowerchiller: {
                label: t.networkPowerChiller.content,
                imageComponent: PowerConversionImage,
            },
            apc: {
                label: t.apc.content,
                imageComponent: PowerConversionImage,
            },
            pcsandnotebooks: {
                label: t.pcsAndNotebooks.content,
                imageComponent: LowVoltDcImage,
            },
            server: {
                label: t.server.content,
                imageComponent: BmsLowVoltImage,
            },
        };
    }, [contentTree]);

    return { components };
};

export type ComputingComponentName = keyof ReturnType<typeof useComputingComponents>['components'];
